import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";

import Loader from "../../components/Loader";
import useAuth from "../../hooks/useAuth";

// import images
import logo from "../../assets/images/SATI/IBi-logo.png";

/**
 * Login Component
 * Refined for 100% coherence with DATA_DASHBOARD Sidebar.
 */
const Login = () => {
  const history = useHistory();
  const { login, loading, error: authError } = useAuth();
  
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    login({ username, password }, history);
  };

  const handleCancel = () => {
    setUsername("");
    setPassword("");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      {loading && <Loader />}
      
      <div className="w-full max-w-md">
        <div className="bg-white rounded-[2rem] shadow-xl p-10 border border-brand-gray-light/20">
          {/* Logo and Title */}
          <div className="flex flex-col items-center mb-10">
            <div className="h-16 mb-4 flex items-center justify-center">
              <img src={logo} alt="IBICARE" className="h-full w-auto object-contain" />
            </div>
            <p className="text-brand-gray-dark text-sm mt-2 font-medium">
              Inicia sesión para continuar
            </p>
          </div>

          {/* Error Message */}
          {authError && (
            <div className="mb-6 p-4 bg-red-50 border border-red-100 rounded-2xl">
              <p className="text-red-600 text-sm font-medium">{authError}</p>
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Username Field */}
            <div>
              <label
                htmlFor="username"
                className="block text-sm font-semibold text-brand-navy mb-2 ml-1"
              >
                Usuario
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Tu Usuario"
                required
                disabled={loading}
                className="w-full px-4 py-3.5 rounded-2xl border border-gray-100 bg-gray-50/50 
                         focus:outline-none focus:border-brand-blue focus:bg-white
                         disabled:opacity-50 disabled:cursor-not-allowed
                         transition-all duration-200 text-sm placeholder:text-gray-400"
              />
            </div>

            {/* Password Field */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-semibold text-brand-navy mb-2 ml-1"
              >
                Contraseña
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  disabled={loading}
                  className="w-full px-4 py-3.5 rounded-2xl border border-gray-100 bg-gray-50/50 
                           focus:outline-none focus:border-brand-blue focus:bg-white
                           disabled:opacity-50 disabled:cursor-not-allowed
                           transition-all duration-200 text-sm placeholder:text-gray-400"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-4 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FiEyeOff className="h-5 w-5 text-brand-gray-dark hover:text-brand-navy transition-colors" />
                  ) : (
                    <FiEye className="h-5 w-5 text-brand-gray-dark hover:text-brand-navy transition-colors" />
                  )}
                </button>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-between pt-4">
              <button
                type="button"
                onClick={handleCancel}
                disabled={loading}
                className="px-4 py-2 text-brand-gray-dark hover:text-brand-navy 
                         disabled:opacity-50 disabled:cursor-not-allowed
                         transition-colors text-sm font-bold uppercase tracking-wider"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading || !username || !password}
                className="px-8 py-3 bg-brand-blue text-white rounded-2xl
                         hover:bg-brand-blue/90 active:scale-[0.98] disabled:opacity-50 
                         disabled:cursor-not-allowed transition-all text-sm font-bold 
                         shadow-lg shadow-brand-blue/20 uppercase tracking-widest"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Cargando
                  </span>
                ) : (
                  'Ingresar'
                )}
              </button>
            </div>
          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-brand-gray-dark text-xs mt-8 font-medium">
          © {new Date().getFullYear()} IBICARE. Todos los derechos reservados.
        </p>
      </div>
    </div>
  );
};

export default Login;
